import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar.jsx';
import Footer from './Footer.jsx';
import BottomNav from './BottomNav.jsx';
import GoogleTranslate from './GoogleTranslate.jsx';
import CookieConsent from './CookieConsent.jsx';

export default function SiteLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((v) => !v);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to main content
      </a>
      <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Outlet />
      <Footer />
      <BottomNav menuOpen={menuOpen} onToggleMenu={toggleMenu} />
      <GoogleTranslate />
      <CookieConsent />
    </>
  );
}
